export enum StorageBatteryTechnology {
  LI_ION = 'LI_ION',
  NAS = 'NAS',
  REDOX_FLOW = 'REDOX_FLOW',
}
export const storageBatteryTechnologyToLabel = {
  [StorageBatteryTechnology.LI_ION]: 'Li Ion',
  [StorageBatteryTechnology.NAS]: 'NaS',
  [StorageBatteryTechnology.REDOX_FLOW]: 'Redox Flow',
};
